import { useEffect, useRef, useState } from "react";
import Layout from "@components/shared/layout";
import ErrorMsgLabel from "@components/shared/errorMsgLabel";
import { Form, Button, Input } from "semantic-ui-react";
import CustomSnackbar from "@components/shared/custom_snackbar";
import { selectFieldStyle, selectFieldStyleError } from "@utils/const";
import {
  getEstados,
  getConselhos,
  getOcupacoes,
  postProfissionalExecutante,
  putProfissionalExecutante,
  getPrestador,
  updatePrestador,
} from "@store/actions/index";
import Select from "react-select";
import AjaxLoader from "@components/shared/ajax_loader";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import m from "@utils/strings";
import "@styles/profissionais-executantes.css";
import _ from "lodash";
import userManager from "@utils/userManager";
import { bindActionCreators } from "redux";

function CadastrarEditarProfissional(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    nome: "",
    ocupacoesSelecionadas: "",
    numeroConselho: "",
    estado: "",
    conselho: "",
    idProfissional: null,
    snackbarType: "error",
    snackbarMsg: "",
    isRegisterScreen: true,
    showPrestadorLoader: false,
  });
  const textInputRef = useRef();
  const [ocupacoes, setOcupacoes] = useState([]);
  const [conselhos, setConselhos] = useState([]);
  const [estados, setEstados] = useState([]);
  const snackbarRef = useRef();
  const verifiyIfUserIsAuthenticated = () => {
    const { user } = props;
    if (!user || user.expired) {
      userManager.signinRedirect();
    }
  };

  const getUpdatePrestador = () => {
    const { user } = props;
    if (user != null && user.profile != null) {
      if (!isFetchingPrestador) {
        isFetchingPrestador = true;
        let cpfCnpj =
          user.profile.prestador instanceof Array
            ? user.profile.prestador[0]
            : user.profile.prestador;
        props.getPrestador(cpfCnpj, (result) => {
          props.updatePrestador(result);
          setState((prevState) => ({
            ...prevState,
            showPrestadorLoader: false,
          }));
        });
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key == "Enter") {
      handleSubmit();
      event.preventDefault();
    }
  };

  const handleInputChange = (event, { name, value }) => {
    const { nome, numeroConselho } = state;
    if (name == "nome") {
      value = value.replace(/([.*+?=!:;>,<"'&%$#@${}()|\[\]\\/\-\_0-9])/g, "");
      if (value.length > 70) value = nome;
    } else if (name == "numeroConselho") {
      value = value.replace(
        /([.*+?^=!:;>,<"'´`~&%$#@${}()|\[\]\\a-z\ A-Z\/\-\_])/g,
        ""
      );
      if (value.length > 15) value = numeroConselho;
    }
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleOcupacaoInputChange = (event) => {
    setState((prevState) => ({ ...prevState, ocupacoesSelecionadas: event }));
  };

  const handleEstadoInputChange = (event) => {
    setState((prevState) => ({
      ...prevState,
      estado: { value: event.label, label: event.label },
    }));
  };

  const handleConselhoInputChange = (event) => {
    setState((prevState) => ({
      ...prevState,
      conselho: { value: event.label, label: event.label },
    }));
  };

  const loadInputDatas = () => {
    props.getOcupacoes((result) => {
      let ocupacoesInput = result.data.map((ocupacao) => {
        return {
          Descricao: ocupacao.Descricao,
          Id: ocupacao.Id,
        };
      });
      setOcupacoes(ocupacoesInput);
    });
    props.getEstados((result) => {
      let estados = result.data.map((estado) => {
        return estado.Descricao;
      });
      setEstados(estados);
    });
    props.getConselhos((result) => {
      let conselhos = result.data.map((conselho) => {
        return conselho.Descricao;
      });
      setConselhos(conselhos);
      conselhos = conselhos;
    });
  };

  const handleSubmit = () => {
    setState((prevState) => ({ ...prevState, hasSubmitted: true }));
    let paramsProfissional = {},
      paramsOcupacoes = [];
    const {
      nome,
      ocupacoesSelecionadas,
      estado,
      numeroConselho,
      conselho,
      isRegisterScreen,
      idProfissional,
    } = state;
    const { postProfissionalExecutante, prestador } = props;

    if (
      !_.isEmpty(ocupacoesSelecionadas) &&
      !_.isEmpty(conselho) &&
      !_.isEmpty(conselho.label) &&
      !_.isEmpty(estado) &&
      !_.isEmpty(estado.label) &&
      !_.isEmpty(numeroConselho) &&
      !_.isEmpty(nome)
    ) {
      !_.isEmpty(conselho) && !_.isEmpty(conselho.label)
        ? (paramsProfissional.conselho = conselho.label)
        : {};
      !_.isEmpty(estado) && !_.isEmpty(estado.label)
        ? (paramsProfissional.estado = estado.label)
        : {};
      !_.isEmpty(numeroConselho)
        ? (paramsProfissional.numeroConselho = numeroConselho)
        : {};
      !_.isEmpty(prestador)
        ? (paramsProfissional.idprestador = prestador.Id)
        : {};
      !_.isEmpty(nome) ? (paramsProfissional.nome = nome) : {};
      !isRegisterScreen ? (paramsProfissional.id = idProfissional) : {};

      if (!_.isEmpty(ocupacoesSelecionadas)) {
        ocupacoes.forEach((ocupacaoArray) => {
          ocupacoesSelecionadas.forEach((ocupacaoSelecionada) => {
            if (ocupacaoArray.Descricao == ocupacaoSelecionada.value) {
              paramsOcupacoes.push(ocupacaoArray);
            }
          });
        });
      }

      let ocupacoesSemRepeticoes = []; //remove duplicidades, caso existam no banco
      paramsOcupacoes.forEach((paramOcupacao) => {
        let isAlreadyThere = false;
        ocupacoesSemRepeticoes.forEach((ocupacaoNaoRepetida) => {
          if (paramocupacao.Descricao == ocupacaoNaoRepetida.descricao) {
            isAlreadyThere = true;
          }
        });
        if (!isAlreadyThere) {
          ocupacoesSemRepeticoes.push(paramOcupacao);
        }
      });

      if (isRegisterScreen) {
        postProfissionalExecutante(          
          {
            profissionalExecutante: { ...paramsProfissional },
            ocupacoes: ocupacoesSemRepeticoes,
          },
          (result) => {
            navigate("/profissionais-executantes", {
              state: {
                statusResponse: "success",
                messageResponse:
                  m.TELA_PROFISSIONAIS_EXECUTANTES
                    .NOTIFICACAO_PROFISSIONAL_CADASTRADO_SUCESSO,
              },
            });
          },
          (error) => {
            if (
              error &&
              error.response &&
              error.response.status &&
              error.response.status == 409
            )
              callSnackbar(
                m.TELA_PROFISSIONAIS_EXECUTANTES
                  .NOTIFICACAO_PROFISSIONAL_JA_CADASTRADO,
                "error"
              );
            else
              callSnackbar(
                m.TELA_PROFISSIONAIS_EXECUTANTES.NOTIFICACAO_ERRO_CADASTRAR,
                "error"
              );
          }
        );
      } else {
        putProfissionalExecutante(
          {
            profissionalExecutante: { ...paramsProfissional },
            ocupacoes: ocupacoesSemRepeticoes,
          },
          (result) => {
            navigate("/profissionais-executantes", {
              state: {
                statusResponse: "success",
                messageResponse:
                  m.TELA_PROFISSIONAIS_EXECUTANTES
                    .NOTIFICACAO_PROFISSIONAL_EDITADO_SUCESSO,
              },
            });
          },
          (error) => {
            callSnackbar(
              m.TELA_PROFISSIONAIS_EXECUTANTES.NOTIFICACAO_ERRO_EDITAR,
              "error"
            );
          }
        );
      }
    } else {
      return;
    }
  };

  const focus = () => {
    setTimeout(() => {
      textInputRef?.current.focus();
    }, 1000);
  };

  const callSnackbar = (snackbarMsg, snackbarType) => {
    setState((prevState) => ({ ...prevState, snackbarMsg, snackbarType }));
    snackbarRef?.current.handleClick();
  };

  useEffect(() => {
    if (_.isEmpty(props.prestador)) {
      setState((prevState) => ({ ...prevState, showPrestadorLoader: true }));
      getUpdatePrestador();
    }
    loadInputDatas();

    let nome = "",
      ocupacoes = [],
      conselho = "",
      numeroConselho = "",
      estado = "",
      idProfissional;
    if (location?.state) {
      idProfissional = location.state.idProfissional;
      nome = location.state.nome;
      ocupacoes = location.state.ocupacoes;
      conselho = location.state.conselho;
      numeroConselho = location.state.numeroConselho;
      estado = location.state.estado;
      setState((prevState) => ({
        ...prevState,
        idProfissional: idProfissional,
        nome: nome,
        ocupacoesSelecionadas: ocupacoes
          ? ocupacoes.map((ocupacaoArray) => {
              return {
                value: ocupacaoArray.Descricao,
                label: `${ocupacaoArray.Id} - ${ocupacaoArray.Descricao}`,
              };
            })
          : [],
        conselho: { value: conselho, label: conselho },
        numeroConselho: numeroConselho,
        estado: { value: estado, label: estado },
        isRegisterScreen: false,
      }));
    } else {
      setState((prevState) => ({ ...prevState, isRegisterScreen: true }));
    }
    document.addEventListener("keydown", handleKeyDown, false);
    return () => {
      verifiyIfUserIsAuthenticated();
      document.removeEventListener("keydown", handleKeyDown, false);
    };
    focus();
  }, []);

  useEffect(() => {
    verifiyIfUserIsAuthenticated();
  });

  const render = () => {
    const { user } = props;
    const { isRegisterScreen, showPrestadorLoader } = state;

    const prestadorLoader = showPrestadorLoader ? (
      <AjaxLoader
        ajaxMessage={
          m.TELA_PROFISSIONAIS_EXECUTANTES.MENSAGEM_LOADER_BUSCANDO_PRESTADOR
        }
      />
    ) : (
      ""
    );

    return (
      <div>
        {prestadorLoader}
        <Layout
          user={user}
          iconePath=""
          content={
            isRegisterScreen
              ? m.TELA_PROFISSIONAIS_EXECUTANTES.TITULO_CADASTRAR_PROFISSIONAL
              : `${m.TELA_PROFISSIONAIS_EXECUTANTES.TITULO_EDITAR_PROFISSIONAL} ${state.nome}`
          }
        />
        <div className="form-cadastro-profissional-container">
          <Form>
            <Form.Group>
              <Form.Field inline={true} width={6}>
                <div>
                  <label className={"form-autorizacao-label"}>
                    {
                      m.TELA_PROFISSIONAIS_EXECUTANTES
                        .LABEL_NOME_PROFISSIONAL_SOLICITANTE
                    }
                  </label>
                </div>
                <div>
                  <Input
                    name="nome"
                    ref={textInputRef}
                    error={_.isEmpty(state.nome) && state.hasSubmitted}
                    onChange={handleInputChange}
                    value={state.nome}
                  />
                </div>
                <ErrorMsgLabel
                  boolean={_.isEmpty(state.nome) && state.hasSubmitted}
                  message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
                />
              </Form.Field>
              <Form.Field inline={true} width={5}>
                <div>
                  <label className={"form-autorizacao-label"}>
                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OCUPACAO}
                  </label>
                </div>
                <Select
                  name="ocupacao"
                  value={state.ocupacoesSelecionadas}
                  onChange={handleOcupacaoInputChange}
                  placeholder=""
                  isMulti
                  noOptionsMessage={({ inputValuetringrequired }) => {
                    return m.TELA_PROFISSIONAIS_EXECUTANTES
                      .MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA;
                  }}
                  styles={
                    !_.isEmpty(state.ocupacoesSelecionadas) ||
                    !state.hasSubmitted
                      ? selectFieldStyle
                      : selectFieldStyleError
                  }
                  options={ocupacoes.map((ocupacao) => {
                    return {
                      value: ocupacao.Descricao,
                      label: `${ocupacao.Id} - ${ocupacao.Descricao}`,
                    };
                  })}
                />
                <ErrorMsgLabel
                  boolean={
                    _.isEmpty(state.ocupacoesSelecionadas) && state.hasSubmitted
                  }
                  message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field inline={true} width={2}>
                <div>
                  <label className={"form-autorizacao-label"}>
                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_CONSELHO}
                  </label>
                </div>
                <Select
                  name="conselho"
                  value={state.conselho}
                  onChange={handleConselhoInputChange}
                  placeholder=""
                  noOptionsMessage={({ inputValuetringrequired }) => {
                    return m.TELA_PROFISSIONAIS_EXECUTANTES
                      .MENSAGEM_NENHUM_CONSELHO_ENCONTRADO;
                  }}
                  styles={
                    !_.isEmpty(state.conselho) || !state.hasSubmitted
                      ? selectFieldStyle
                      : selectFieldStyleError
                  }
                  options={conselhos.map((conselho) => {
                    return { value: "conselho", label: conselho };
                  })}
                />
                <ErrorMsgLabel
                  boolean={_.isEmpty(state.conselho) && state.hasSubmitted}
                  message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
                />
              </Form.Field>
              <Form.Field inline={true} width={2}>
                <div>
                  <label className={"form-autorizacao-label"}>
                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_ESTADO}
                  </label>
                </div>
                <Select
                  name="estado"
                  value={state.estado}
                  onChange={handleEstadoInputChange}
                  placeholder=""
                  noOptionsMessage={({ inputValuetringrequired }) => {
                    return m.TELA_PROFISSIONAIS_EXECUTANTES
                      .MENSAGEM_NENHUM_ESTADO_ENCONTRADO;
                  }}
                  styles={
                    !_.isEmpty(state.estado) || !state.hasSubmitted
                      ? selectFieldStyle
                      : selectFieldStyleError
                  }
                  options={estados.map((estado) => {
                    return { value: "estado", label: estado };
                  })}
                />
                <ErrorMsgLabel
                  boolean={_.isEmpty(state.estado) && state.hasSubmitted}
                  message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
                />
              </Form.Field>
              <Form.Field inline={true} width={3}>
                <div>
                  <label className={"form-autorizacao-label"}>
                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_NUMERO_CONSELHO}
                  </label>
                </div>
                <div>
                  <Form.Input
                    name="numeroConselho"
                    error={!(state.numeroConselho || !state.hasSubmitted)}
                    onChange={handleInputChange}
                    value={state.numeroConselho}
                  />
                </div>
                <ErrorMsgLabel
                  boolean={
                    _.isEmpty(state.numeroConselho) && state.hasSubmitted
                  }
                  message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field inline={true} width={2}>
                <Link to="/profissionais-executantes">
                  <div className="label-cadastro-profissional-cancelar">
                    CANCELAR
                  </div>
                </Link>
              </Form.Field>
              <Form.Field inline={true} width={3}>
                <Button
                  onClick={handleSubmit}
                  className={"btn-form-cemig"}
                  style={{ marginTop: 20 }}
                >
                  {isRegisterScreen
                    ? m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_CADASTRAR
                    : m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_EDITAR}{" "}
                  (ENTER)
                </Button>
              </Form.Field>
            </Form.Group>
          </Form>
        </div>
        <CustomSnackbar
          ref={snackbarRef}
          variant={state.snackbarType}
          duration={2500}
          content={state.snackbarMsg}
        />
      </div>
    );
  };
  return render();
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    prestador: state.prestador,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getConselhos,
      getEstados,
      getOcupacoes,
      putProfissionalExecutante,
      postProfissionalExecutante,
      getPrestador,
      updatePrestador,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastrarEditarProfissional);
